import React from "react";

import { ProtectedRoute, RouteItem } from "../core/routing/ProtectedRoute";
import { SprintAccessRight } from "../core/security/SprintAccessRight";
import { MaterialOrderReportDashboard } from "./buzz-order/BuzzOrderReportDashboard";

export const reportsBasePath = "/reports";

const reportMinAccess = [SprintAccessRight.OrdRead];

export const materialOrderReportRoute: RouteItem = {
    path: `${reportsBasePath}/material-order-report`,
    component: () => MaterialOrderReportDashboard(),
    accessRights: reportMinAccess,
    name: "Material Order Report"
};

export const ReportsRoutes = (): JSX.Element => {
    return <ProtectedRoute protectedRouteData={materialOrderReportRoute} />;
};
